import { useState } from "react";

import clsx from "clsx";

import BenchmarkMarketingLogoV2 from "@assets/benchmarking-marketing-logo-v2.svg";
import { useFeatureFlags } from "@hooks/http";
import { PrimaryButton } from "@shared/buttons";

import { BenchmarkAttributionWindowValues } from "../constants";
import { useBenchmarkAttributionWindow } from "../hooks";

import { Alert } from "./alert";

export const BenchmarkAvailabilityCard = ({
  available,
  onContinue,
}: {
  available: boolean;
  onContinue: () => void;
}) => {
  const { hasFeatureFlag } = useFeatureFlags();
  const [play, setPlay] = useState(false);
  const [currentAttributionWindow] = useBenchmarkAttributionWindow();

  return (
    <div className="w-full py-5 flex items-center">
      <div className="w-[45%] relative">
        {!play ? (
          <>
            <i
              className={clsx(
                "fa-regular fa-sharp fa-circle-play absolute text-[6rem]",
                "left-[50%] top-[50%] z-[1] py-[0.5rem] px-[0.5rem] hover:text-primary",
                "cursor-pointer",
              )}
              style={{ transform: "translate(-50%, -50%)" }}
              onClick={() => setPlay(true)}
            />
            <img
              className="w-full"
              alt="benchmark-marketing-logo"
              src={BenchmarkMarketingLogoV2}
            />
          </>
        ) : (
          <iframe
            width="100%"
            height="500px"
            src="https://www.youtube.com/embed/KuoiBEuhiro?&autoplay=1"
            title="YouTube video player"
            frameBorder="0"
            allow={
              "accelerometer; autoplay; clipboard-write; encrypted-media; " +
              "gyroscope; picture-in-picture; web-share"
            }
            allowFullScreen
          />
        )}
      </div>
      <div className="flex flex-col ml-10">
        {!available && (
          <div className="mb-7">
            <Alert>
              You need{" "}
              {BenchmarkAttributionWindowValues[currentAttributionWindow] * 2}{" "}
              days of data to start using benchmarks
              <a
                href="https://docs.northbeam.io/docs/sales-page#benchmarking-tool"
                target="_blank"
                rel="noreferrer"
                className="ml-2"
              >
                Learn more
              </a>
            </Alert>
          </div>
        )}
        <div className="text-lg text-primary font-semibold">
          {available ? "Now available" : "Not available"}
        </div>
        <div className="text-4xl font-bold mt-4 max-w-2xl leading-[48px]">
          <div>To scale or cut?</div>
          <div>Set up your Benchmarks to make the decision easier.</div>
        </div>
        <div className="mt-4 max-w-2xl text-lg text-gray+2 font-light">
          Benchmarks take out the guesswork by showing how your are trending
          day-to-day against your baseline performance. Measurements are
          calculated using your past performance data.
        </div>
        {available && (
          <PrimaryButton
            onClick={onContinue}
            className="text-base w-[14rem] mt-6 p-[8px] rounded-full"
          >
            SET UP BENCHMARKS
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};
